export const LANGUAGE = [
    'Chinese',
    'English',
    'French',
    'German',
    'Italian',
    'Japanese',
    'Korean',
];
export const TONE = [
    'Casual',
    'Formal',
    'Friendly',
    'Humorous',
    'Professional',
    'Straightforward',
];
//# sourceMappingURL=config.js.map